export default __webpack_public_path__ + "d145df128a5b3aa54383669d3ab526b1.png";